// src/pages/novoEvento/utils/normalizers.js
export function formatBRL(value) {
    const n = Number(value || 0);
    return n.toLocaleString("pt-BR", { style: "currency", currency: "BRL" });
}

export function getBannerSrc(s) {
    return (
        s.identidade.banner.previewUrl ||
        (s.identidade.banner.mode === "url" ? s.identidade.banner.url : "") ||
        ""
    );
}

export function minTicketPrice(s) {
    const prices = (s.ingressos || []).map((t) => Number(t.preco || 0)).filter((x) => x >= 0);
    if (!prices.length) return 0;
    return Math.min(...prices);
}

export function buildEventDetailsMockFromState(s) {
    const banner = getBannerSrc(s);

    const city = `${s.dataLocal.local.cidade || ""} · ${s.dataLocal.local.estado || ""}`.trim();

    const date = s.dataLocal.dataInicio
        ? new Date(`${s.dataLocal.dataInicio}T00:00:00`).toLocaleDateString("pt-BR", {
            weekday: "long",
            day: "2-digit",
            month: "long",
            year: "numeric",
        })
        : "";

    const time = s.dataLocal.aberturaPortoes
        ? `Abertura dos portões às ${s.dataLocal.aberturaPortoes}`
        : s.dataLocal.horaInicio
            ? `Início às ${s.dataLocal.horaInicio}`
            : "";

    return {
        banner,
        title: s.identidade.titulo,
        date,
        time,
        city,
        classification: `${s.identidade.classificacao} anos`,
        description: s.descricao.texto,
        tickets: s.ingressos.map((t) => ({
            id: t.id,
            name: `${t.nome} | ${t.lote}`,
            price: Number(t.preco || 0),
        })),
        salesPoints: s.vendas.pontosFisicos || [],
        commissaries: (s.vendas.comissarios || []).map((c) => ({ name: c.nome, phone: c.phone })),
    };
}
